module.exports = __webpack_public_path__ + "static/media/magnifier.6c8cf0d0.svg";